(function () {
  // Recommended: exactly N checkboxes must be selected (matches ticket price)
  const REQUIRE_EXACT = true;

  function getBookingForms() {
    return Array.from(document.querySelectorAll('form[data-type="add-to-cart-form"]')).filter((form) =>
      form.querySelector(".booking-block")
    );
  }

  function getVariantId(form) {
    const input = form.querySelector('input[name="id"]');
    return input && input.value ? String(input.value) : null;
  }

  function getVariantMap(form) {
    const mapEl = form.querySelector(".booking-variant-map");
    if (!mapEl) return null;
    try {
      return JSON.parse(mapEl.textContent.trim());
    } catch (e) {
      return null;
    }
  }

  function getBookingBlock(form) {
    return form.querySelector(".booking-block");
  }

  function getCheckboxes(form) {
    const block = getBookingBlock(form);
    if (!block) return [];
    return Array.from(block.querySelectorAll(".booking-day-checkbox"));
  }

  function selectedCheckboxes(form) {
    return getCheckboxes(form).filter((cb) => cb.checked);
  }

  function selectedCount(form) {
    return selectedCheckboxes(form).length;
  }

  function setHint(form, text) {
    const hint = form.querySelector(".booking-hint");
    if (hint) hint.textContent = text;
  }

  function setCheckboxesEnabled(form, enabled) {
    const block = getBookingBlock(form);
    if (!block) return;

    block.querySelectorAll(".booking-day-checkbox").forEach((cb) => {
      cb.disabled = !enabled;
      const label = cb.closest("label");
      if (label) {
        label.style.opacity = enabled ? "" : "0.6";
        label.style.pointerEvents = enabled ? "" : "none";
      }
    });
  }

  function getActionButtons(form) {
    const inForm = Array.from(form.querySelectorAll("button, input[type='submit']"));
    const wrapper = form.closest("product-form-component") || form.parentElement;
    const nearby = wrapper
      ? Array.from(wrapper.querySelectorAll(".shopify-payment-button__button, .shopify-payment-button__more-options"))
      : [];
    return Array.from(new Set([...inForm, ...nearby]));
  }

  function setButtonsDisabled(form, disabled) {
    const buttons = getActionButtons(form);
    buttons.forEach((btn) => {
      if (btn.dataset.bookingOriginalDisabled == null) {
        btn.dataset.bookingOriginalDisabled = btn.disabled ? "true" : "false";
      }
      const originallyDisabled = btn.dataset.bookingOriginalDisabled === "true";
      btn.disabled = originallyDisabled ? true : disabled;

      if (!originallyDisabled) {
        btn.style.opacity = disabled ? "0.6" : "";
        btn.style.pointerEvents = disabled ? "none" : "";
      }
    });
  }

  function updateMarker(form, max) {
    const block = getBookingBlock(form);
    if (!block) return;

    const marker = block.querySelector(".booking-selected-marker");
    if (!marker) return;

    const count = selectedCount(form);
    marker.value = max ? `${count} of ${max} day(s) selected` : "";
  }

  // Store selection order so we can remove the "oldest" when over max
  function getOrder(form) {
    try {
      return JSON.parse(form.dataset.bookingOrder || "[]");
    } catch {
      return [];
    }
  }

  function setOrder(form, arr) {
    form.dataset.bookingOrder = JSON.stringify(arr);
  }

  function syncOrderFromDOM(form) {
    const cbs = getCheckboxes(form);
    const order = getOrder(form);

    // keep only ids that still exist and are still checked
    const existingCheckedIds = new Set(
      cbs.filter((cb) => cb.checked).map((cb) => cb.id)
    );

    const cleaned = order.filter((id) => existingCheckedIds.has(id));

    // add any checked boxes not in order yet (rare)
    cbs.forEach((cb) => {
      if (cb.checked && cb.id && !cleaned.includes(cb.id)) cleaned.push(cb.id);
    });

    setOrder(form, cleaned);
  }

  // Auto-select first N checkboxes and set order accordingly
  function selectFirstN(form, n) {
    const cbs = getCheckboxes(form);
    if (cbs.length === 0) return;

    // uncheck all first
    cbs.forEach((cb) => (cb.checked = false));

    // check first n
    const chosen = cbs.slice(0, n);
    chosen.forEach((cb) => (cb.checked = true));

    // reset order
    setOrder(
      form,
      chosen.map((cb) => cb.id)
    );
  }

  // Enforce max by unchecking the OLDEST selected (keeping the newest click)
  function enforceMaxKeepNewest(form, max) {
    const cbs = getCheckboxes(form);
    if (cbs.length === 0) return;

    syncOrderFromDOM(form);

    let order = getOrder(form);
    let checked = selectedCheckboxes(form);

    while (checked.length > max) {
      // uncheck oldest
      const oldestId = order.shift();
      if (oldestId) {
        const oldest = cbs.find((cb) => cb.id === oldestId);
        if (oldest) oldest.checked = false;
      }
      checked = selectedCheckboxes(form);
    }

    // clean order again
    syncOrderFromDOM(form);
  }

  function ensureCheckboxIds(form) {
    // We need stable IDs for order tracking.
    // If theme doesn't provide IDs, add our own.
    const cbs = getCheckboxes(form);
    cbs.forEach((cb, idx) => {
      if (!cb.id) cb.id = `booking_day_${idx + 1}`;
    });
  }

  function update(form, reason) {
    const bookingBlock = getBookingBlock(form);
    if (!bookingBlock) return;

    ensureCheckboxIds(form);

    const map = getVariantMap(form) || {};
    const variantId = getVariantId(form);
    const max = variantId && map[variantId] ? Number(map[variantId]) : null;

    if (!max || isNaN(max) || max <= 0) {
      // If mapping fails, safest: lock
      setCheckboxesEnabled(form, false);
      setButtonsDisabled(form, true);
      setHint(form, "Ticket option selected, but pass size not detected. Check variant titles start with 1/2/3.");
      updateMarker(form, null);
      return;
    }

    // Always enabled now (because default variant exists), we are removing the "must click ticket first" concept
    setCheckboxesEnabled(form, true);

    // If pass changed OR first load, auto-select first N
    const lastMax = form.dataset.bookingLastMax ? Number(form.dataset.bookingLastMax) : null;
    const isFirstLoad = !form.dataset.bookingInitialized;

    if (isFirstLoad || lastMax !== max) {
      selectFirstN(form, max);
      form.dataset.bookingLastMax = String(max);
    }

    // If user manually changed a checkbox, enforce max by removing oldest
    // (reason === 'checkbox' indicates user clicked a checkbox)
    if (reason === "checkbox") {
      enforceMaxKeepNewest(form, max);
    }

    // Update marker and validation
    const count = selectedCount(form);
    updateMarker(form, max);

    let valid = false;
    if (REQUIRE_EXACT) {
      valid = count === max;
      setHint(form, valid ? "Perfect — you can add to cart." : `Select exactly ${max} day(s).`);
    } else {
      valid = count >= 1 && count <= max;
      setHint(form, valid ? "Perfect — you can add to cart." : `Select up to ${max} day(s).`);
    }

    setButtonsDisabled(form, !valid);

    form.dataset.bookingInitialized = "true";
  }

  function init() {
    const forms = getBookingForms();

    forms.forEach((form) => {
      // Initialize tracking
      form.dataset.bookingInitialized = "";
      form.dataset.bookingLastMax = "";
      setOrder(form, []);

      // Initial auto-select based on default variant
      update(form, "init");

      // When checkboxes change: keep newest selection, drop oldest if over max
      form.addEventListener("change", function (e) {
        if (e.target && e.target.classList.contains("booking-day-checkbox")) {
          // record newest click in order
          ensureCheckboxIds(form);

          const cb = e.target;
          syncOrderFromDOM(form);

          let order = getOrder(form);

          // If checked, push to end (newest)
          if (cb.checked) {
            order = order.filter((id) => id !== cb.id);
            order.push(cb.id);
          } else {
            // If unchecked, remove from order
            order = order.filter((id) => id !== cb.id);
          }

          setOrder(form, order);
          update(form, "checkbox");
        }
      });

      // Watch hidden variant id changes (pass change)
      const variantInput = form.querySelector('input[name="id"]');
      if (variantInput) {
        const obs = new MutationObserver(() => {
          update(form, "variant");
        });
        obs.observe(variantInput, { attributes: true, attributeFilter: ["value"] });
      }
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
